export default "__VITE_ASSET__9d3a3eae__"